import { createApi } from '@reduxjs/toolkit/query/react';

import { SurveyLanguage } from '@/graphql/generated';
import { Unit } from '@/slices/units/units.type';

import { symfonyBaseQuery } from '@/services/SymfonyClient';

type GetUnitInput = {
  identifier: string;
  locale?: SurveyLanguage;
};

type GetUnitResponse = {
  unit: Unit;
};

const unitsApi = createApi({
  baseQuery: symfonyBaseQuery({
    baseUrl: '/api',
  }),
  reducerPath: 'units',
  tagTypes: ['Units'],
  endpoints: (build) => ({
    getUnit: build.query<Unit, GetUnitInput>({
      query: ({ identifier, locale }) => ({
        url: `/units/${identifier}`,
        method: 'GET',
        params: undefined === locale ? undefined : { locale },
      }),
      transformResponse: (response: GetUnitResponse) => response.unit,
      providesTags: (_result, _error, { identifier }) => [
        { type: 'Units', id: identifier },
      ],
    }),
  }),
});

export default unitsApi;
